import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useCommonStore, useSearchStore } from "../../store/store";
import MLSChip from "../../common/components/search/chips/MLSChip";
import { modules } from "../../constants";

const MLSSelector = ({ module, userId, mlsMembershipInfo, mlsProps }) => {

    const {
        selectedMls,
        setSelectedMls,
        isLoading,
    } = useSearchStore(state => ({
        selectedMls: state[state.selectedModule]?.selectedMls,
        setSelectedMls: state.setSelectedMls,
        isLoading: state.isLoading,
    }));

    const {
        mlsProviders,
        timeIntervals,
    } = useCommonStore(state => ({
        mlsProviders: state.mlsProviders,
        timeIntervals: state.timeIntervals,
    }));

    useEffect(() => {
        if (!selectedMls && !!mlsProviders?.length && !!timeIntervals?.length) {
            setSelectedMls(mlsProviders[0], modules.dashboard.dashboard, timeIntervals);
        }
    }, [selectedMls]);

    return (
        <MLSChip
            key="mls"
            disabled={isLoading}
            module={module}
            selectedMls={selectedMls}
            mlsMembershipInfo={Array.isArray(mlsMembershipInfo) ? mlsMembershipInfo.find((mls) => mls.mlsId === selectedMls?.mlsId) : undefined}
            userId={userId}
            mlsProps={mlsProps}
        />
    );
};

MLSSelector.propTypes = {
    module: PropTypes.string.isRequired,
    userId: PropTypes.string,
    mlsMembershipInfo: PropTypes.array,
    mlsProps: PropTypes.object,
    timeIntervals: PropTypes.array,
    mlsProviders: PropTypes.array,
};

export default MLSSelector;
